/**
 * @file
 * @module
 * @author Qscy qscy2011@sina.com
 */
export default {
  name: '图层视图',
  buttons: [
    {
      title: '打开/关闭 图层视图',
      key: 'Ctrl+Shift+L'
    }
  ]
}
